import syncPublicRouter from "./public.js";
// import syncSaasRouter from "./saas.js";
// import syncFrontRouter from "./front.js";
const constantRouter = [...syncPublicRouter];

// const syncObj = {
//   saas: syncSaasRouter,
//   front: syncFrontRouter
// };

// constantRouter.push(...syncObj[`${process.env.PROJECT_ENV}`]);

export default constantRouter;



// WEBPACK FOOTER //
// ./src/router/sync_router/index.js